var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        { staticClass: "pt-3" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "mb-1",
                      staticStyle: { width: "100%" },
                      attrs: { "no-body": "" }
                    },
                    [
                      _c(
                        "b-card-header",
                        {
                          staticClass: "p-1",
                          attrs: { "header-tag": "header", role: "tab" }
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.accordion1",
                                  modifiers: { accordion1: true }
                                }
                              ],
                              attrs: {
                                block: "",
                                href: "#",
                                variant: "primary"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Search Criteria\n            "
                              ),
                              !_vm.showSearch
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "caret-down", size: "lg" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showSearch
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "caret-up", size: "lg" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            id: "accordion1",
                            visible: "",
                            accordion: "accordion1",
                            role: "tabpanel"
                          },
                          model: {
                            value: _vm.showSearch,
                            callback: function($$v) {
                              _vm.showSearch = $$v
                            },
                            expression: "showSearch"
                          }
                        },
                        [
                          !_vm.printing
                            ? _c(
                                "b-row",
                                { staticClass: "pt-2 pl-1" },
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c("scoring-event-search", {
                                        attrs: {
                                          skip: {
                                            programme: true
                                          },
                                          multiple: {
                                            region: true,
                                            industry: true,
                                            year: true
                                          }
                                        },
                                        on: {
                                          "update:customer": function($event) {
                                            _vm.customer = $event
                                          },
                                          "update:industry": function($event) {
                                            _vm.industries = $event
                                          },
                                          "update:year": function($event) {
                                            _vm.years = $event
                                          },
                                          "update:country": function($event) {
                                            _vm.country = $event
                                          },
                                          "update:region": function($event) {
                                            _vm.regions = $event
                                          },
                                          "update:gear": function($event) {
                                            _vm.gear = $event
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-container",
                                        [
                                          _c(
                                            "b-card",
                                            [
                                              _c("h4", [_vm._v("More Fields")]),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c("survey-run-selection", {
                                                    attrs: {
                                                      "no-new": true,
                                                      customer: _vm.customerId,
                                                      required: false
                                                    },
                                                    on: {
                                                      "update:surveyRun": function(
                                                        $event
                                                      ) {
                                                        _vm.surveyRun = $event
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "g-p-c-session-selection",
                                                    {
                                                      attrs: {
                                                        customer:
                                                          _vm.customerId,
                                                        required: false
                                                      },
                                                      model: {
                                                        value: _vm.gpcSession,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.gpcSession = $$v
                                                        },
                                                        expression: "gpcSession"
                                                      }
                                                    }
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass: "text-left pt-2"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Status\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c("b-form-select", {
                                                    staticClass: "mb-3",
                                                    attrs: {
                                                      options: [
                                                        "",
                                                        "Draft",
                                                        "Sent",
                                                        "Completed"
                                                      ]
                                                    },
                                                    model: {
                                                      value: _vm.sessionStatus,
                                                      callback: function($$v) {
                                                        _vm.sessionStatus = $$v
                                                      },
                                                      expression:
                                                        "sessionStatus"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass: "text-left pt-2"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "date" } },
                                                    [
                                                      _vm._v(
                                                        "Date first entered"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c("datepicker", {
                                                    attrs: {
                                                      id: "date",
                                                      "disabled-dates": {
                                                        from: new Date()
                                                      },
                                                      "clear-button": true
                                                    },
                                                    model: {
                                                      value: _vm.from_date,
                                                      callback: function($$v) {
                                                        _vm.from_date = $$v
                                                      },
                                                      expression: "from_date"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pl-2 pr-2"
                                                    },
                                                    [_vm._v("to")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("datepicker", {
                                                    attrs: {
                                                      id: "date",
                                                      "disabled-dates": {
                                                        from: new Date()
                                                      },
                                                      "clear-button": true
                                                    },
                                                    model: {
                                                      value: _vm.to_date,
                                                      callback: function($$v) {
                                                        _vm.to_date = $$v
                                                      },
                                                      expression: "to_date"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass: "text-left pt-2"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Owner\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c("b-form-input", {
                                                    staticClass: "mb-3",
                                                    attrs: {
                                                      placeholder: "Name....",
                                                      id: "person"
                                                    },
                                                    model: {
                                                      value: _vm.partial_name,
                                                      callback: function($$v) {
                                                        _vm.partial_name = $$v
                                                      },
                                                      expression: "partial_name"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                {
                                                  staticClass: "text-left pt-2"
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v("Keywords")
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    {
                                                      staticClass: "text-left"
                                                    },
                                                    [
                                                      _c("vue-tags-input", {
                                                        attrs: {
                                                          tags: _vm.keywords,
                                                          placeholder:
                                                            "Add keywords..."
                                                        },
                                                        on: {
                                                          "tags-changed": function(
                                                            newTags
                                                          ) {
                                                            return (_vm.keywords = newTags)
                                                          }
                                                        },
                                                        model: {
                                                          value: _vm.keyword,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.keyword = $$v
                                                          },
                                                          expression: "keyword"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "pt-3 pb-3" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "text-center" },
                                [
                                  !_vm.searching
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: { variant: "success" },
                                          on: {
                                            click: function($event) {
                                              _vm.search()
                                            }
                                          }
                                        },
                                        [_vm._v("Search")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    {
                      model: {
                        value: _vm.tabIndex,
                        callback: function($$v) {
                          _vm.tabIndex = $$v
                        },
                        expression: "tabIndex"
                      }
                    },
                    [
                      !_vm.printing
                        ? _c("b-tab", { attrs: { title: "Results" } }, [
                            !_vm.searching
                              ? _c(
                                  "div",
                                  [
                                    _vm.results
                                      ? _c(
                                          "table",
                                          {
                                            staticClass: "table table-striped"
                                          },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Customer")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Goal Setting")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Scoring Event")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("GPC Session")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { staticClass: "text-left" },
                                                  [_vm._v("Problem/Action(s)")]
                                                ),
                                                _vm._v(" "),
                                                _c("th")
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              [
                                                _vm._l(_vm.results, function(
                                                  item
                                                ) {
                                                  return _c(
                                                    "tr",
                                                    {
                                                      key: item.id,
                                                      staticClass: "c"
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-nowrap text-left align-top"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.surveyRun
                                                                  .customer.name
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.surveyRun
                                                                  .customer
                                                                  .country
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                          item.surveyRun
                                                            .customer.region
                                                            ? _c("br")
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.surveyRun
                                                                  .customer
                                                                  .region
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.surveyRun
                                                                  .customer
                                                                  .industry
                                                              ) +
                                                              " \n                    "
                                                          ),
                                                          item.surveyRun
                                                            .customer
                                                            .secondary_industry
                                                            ? _c("br")
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.surveyRun
                                                                  .customer
                                                                  .secondary_industry
                                                              ) +
                                                              " \n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-nowrap text-left align-top"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "moment"
                                                                )(
                                                                  item.date_created,
                                                                  "Do MMM YYYY"
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    Status: " +
                                                              _vm._s(
                                                                item.status
                                                              ) +
                                                              " \n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-nowrap text-left align-top"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.surveyRun
                                                                  .programme
                                                                  .name
                                                              ) + " Programme"
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    Gear: " +
                                                              _vm._s(
                                                                item.gear
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                          _c("br"),
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                item.surveyRun
                                                                  .period
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item.surveyRun
                                                                  .year
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-nowrap text-left align-top"
                                                        },
                                                        [
                                                          item.gpc
                                                            ? _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "moment"
                                                                      )(
                                                                        item.gpc
                                                                          .session_date,
                                                                        "Do MMM YYYY"
                                                                      )
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "\n                      Coach: " +
                                                                    _vm._s(
                                                                      item.gpc
                                                                        .coach_name
                                                                    ) +
                                                                    " \n                      "
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "\n                      Owner: " +
                                                                    _vm._s(
                                                                      item.gpc
                                                                        .responsible_name
                                                                    ) +
                                                                    "\n                    "
                                                                )
                                                              ])
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "text-left align-top"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("Problem:")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                item.problem
                                                              )
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v("Action(s):")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                item.actions
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "align-top"
                                                        },
                                                        [
                                                          _c(
                                                            "b-button-group",
                                                            {
                                                              attrs: {
                                                                vertical: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    variant:
                                                                      "secondary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.session = item
                                                                      _vm.tabIndex = 1
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("View")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    variant:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.$emit(
                                                                        "edit-session",
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("Edit")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "vue-confirmation-button",
                                                                {
                                                                  ref:
                                                                    "deleteButton",
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    css:
                                                                      "btn btn-danger sm",
                                                                    messages: [
                                                                      "Delete",
                                                                      "Are you sure?",
                                                                      "Deleted, reloading....."
                                                                    ]
                                                                  },
                                                                  on: {
                                                                    "confirmation-success": function(
                                                                      $event
                                                                    ) {
                                                                      _vm.deleteItem(
                                                                        item
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                }),
                                                _vm._v(" "),
                                                !_vm.total
                                                  ? _c(
                                                      "tr",
                                                      { staticClass: "c" },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            attrs: {
                                                              colspan: "100"
                                                            }
                                                          },
                                                          [_vm._v("No results")]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.total > 0
                                      ? _c("b-pagination", {
                                          attrs: {
                                            size: "sm",
                                            "total-rows": _vm.total,
                                            "per-page": _vm.pageSize
                                          },
                                          model: {
                                            value: _vm.page,
                                            callback: function($$v) {
                                              _vm.page = $$v
                                            },
                                            expression: "page"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.session
                        ? _c(
                            "b-tab",
                            { attrs: { title: "SMART Goal Session" } },
                            [
                              _c(
                                "div",
                                { attrs: { id: "goal-session-view" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "page" },
                                    [
                                      _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "pb-3 pt-2 align-middle my-auto"
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "align-middle my-auto"
                                            },
                                            [
                                              _c("b-img", {
                                                attrs: {
                                                  left: "",
                                                  src: "/static/traction.png",
                                                  height: "40px"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c("b-img", {
                                                attrs: {
                                                  right: "",
                                                  src:
                                                    "/static/partial_logo.png",
                                                  height: "70px"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "pb-2 text-center" },
                                        [
                                          _c(
                                            "b-col",
                                            { staticClass: "text-left" },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "gpc-title text-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.session.gpc
                                                        ? "GPC - Follow Up"
                                                        : "SMART Goal Session"
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { staticClass: "text-left pb-3" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.session.gpc
                                                      ? "GPC SESSION "
                                                      : ""
                                                  ) + "DATE"
                                                )
                                              ]),
                                              _vm._v(
                                                " - " +
                                                  _vm._s(
                                                    _vm._f("moment")(
                                                      _vm.session.gpc
                                                        ? _vm.session.gpc
                                                            .session_date
                                                        : _vm.session
                                                            .date_created,
                                                      "Do MMMM YYYY"
                                                    )
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { staticClass: "text-left pb-3" },
                                            [
                                              _c("b", [
                                                _vm._v("PROBLEM OWNER")
                                              ]),
                                              _vm._v(
                                                " - " +
                                                  _vm._s(
                                                    _vm.session.problem_owner
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { staticClass: "text-left pb-3" },
                                            [
                                              _c("b", [_vm._v("PROBLEM")]),
                                              _vm._v(
                                                " - " +
                                                  _vm._s(_vm.session.problem) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.session.gpc
                                        ? _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "text-left pb-3"
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v("GROUP MEMBERS")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.session.gpc
                                                          .participants
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { staticClass: "text-left pb-3" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.session.gpc
                                                      ? "GPC "
                                                      : ""
                                                  ) + "ACTIONS"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.session.actions
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { staticClass: "text-left pb-3" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.session.gpc
                                                      ? "GPC FOLLOW UP"
                                                      : "RECOMMENDED STEPS"
                                                  )
                                                )
                                              ]),
                                              _vm._v(
                                                " -  It is recommended the three steps below are followed\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { staticClass: "text-left pb-3" },
                                            [
                                              _c(
                                                "table",
                                                { staticClass: "table" },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass: "thead-light"
                                                    },
                                                    [
                                                      _c("tr", [
                                                        _c("th", {
                                                          staticClass:
                                                            "border-left border-right",
                                                          attrs: {
                                                            scope: "col"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "border-left border-right",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("ACTIVITY")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "border-left border-right",
                                                            attrs: {
                                                              scope: "col"
                                                            }
                                                          },
                                                          [_vm._v("RESOURCE")]
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right text-nowrap"
                                                      },
                                                      [_vm._v("STEP ONE")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "For each of the actions " +
                                                            _vm._s(
                                                              _vm.session.gpc
                                                                ? "from your GPC session"
                                                                : "identified"
                                                            ) +
                                                            " set S.M.A.R.T goals."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "SMART GOAL PLANNER - TEMPLATE"
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right text-nowrap"
                                                      },
                                                      [_vm._v("STEP TWO")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Delegate goals/tasks to staff. If your company has a performance review/ coaching procedure then it is advisable that this delegation is aligned to the staff members ongoing development."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "DELEGATION GUIDE"
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right border-bottom text-nowrap"
                                                      },
                                                      [_vm._v("STEP THREE")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right border-bottom"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Support staff with regular feedback."
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "border-left border-right border-bottom"
                                                      },
                                                      [_vm._v("FEEDBACK GUIDE")]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        { staticClass: "pt-3 footer" },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "text-right align-bottom"
                                            },
                                            [
                                              _c("b-img", {
                                                staticClass: "img-responsive",
                                                attrs: {
                                                  right: "",
                                                  fluid: "",
                                                  src: "/static/footer.png"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "sf-copy carousel-caption text-right pb-0"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    © Success Formula " +
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          new Date(),
                                                          "YYYY"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.smartGoals, function(smartGoal) {
                                    return _vm.smartGoals &&
                                      _vm.smartGoals.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            key: smartGoal.id,
                                            staticClass: "page"
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "pb-3 pt-2 align-middle my-auto"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "align-middle my-auto"
                                                  },
                                                  [
                                                    _c("b-img", {
                                                      attrs: {
                                                        left: "",
                                                        src:
                                                          "/static/traction.png",
                                                        height: "40px"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c("b-img", {
                                                      attrs: {
                                                        right: "",
                                                        src:
                                                          "/static/partial_logo.png",
                                                        height: "70px"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              {
                                                staticClass: "pb-2 text-center"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _c(
                                                      "h2",
                                                      {
                                                        staticClass:
                                                          "gpc-title text-center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "S.M.A.R.T GOAL Planner"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "pb-2 text-center border-left border-right border-top border-bottom"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "gpc-title text-center goal-header"
                                                      },
                                                      [_vm._v("S")]
                                                    ),
                                                    _c("b", [
                                                      _vm._v("PECIFIC - ")
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.session.gpc
                                                            ? "GPC"
                                                            : ""
                                                        ) +
                                                        " ACTION\n                  "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          smartGoal.s
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "pb-2 text-center border-left border-right border-top border-bottom"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "gpc-title text-center goal-header"
                                                      },
                                                      [_vm._v("M")]
                                                    ),
                                                    _c("b", [
                                                      _vm._v("EASURES - ")
                                                    ]),
                                                    _vm._v(
                                                      " HOW WILL YOU KNOW IT WAS SUCCESSFUL (Lag and Lead Metrics)\n                  "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          smartGoal.m
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "pb-2 text-center border-left border-right border-top border-bottom"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "gpc-title text-center goal-header"
                                                      },
                                                      [_vm._v("A")]
                                                    ),
                                                    _c("b", [
                                                      _vm._v("CTION - ")
                                                    ]),
                                                    _vm._v(
                                                      " LIST THE MAIN TASKS\n                  "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          smartGoal.a
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "pb-2 text-center border-left border-right border-top border-bottom"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "gpc-title text-center goal-header"
                                                      },
                                                      [_vm._v("R")]
                                                    ),
                                                    _c("b", [
                                                      _vm._v("ELEVANCE - ")
                                                    ]),
                                                    _vm._v(
                                                      " LIST BENEFITS FOR BUSINESS\n                  "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          smartGoal.r
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "pb-2 text-center border-left border-right border-top border-bottom"
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "gpc-title text-center goal-header"
                                                      },
                                                      [_vm._v("T")]
                                                    ),
                                                    _c("b", [_vm._v("IME - ")]),
                                                    _vm._v(
                                                      " DECIDE TIMEFRAMES, WHEN THIS GOAL AND TASKS SHOULD BE FINISHED\n                  "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          smartGoal.t
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              { staticClass: "pt-3" },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "text-right align-bottom sf-copy pb-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  © Success Formula " +
                                                        _vm._s(
                                                          _vm._f("moment")(
                                                            new Date(),
                                                            "YYYY"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  }),
                                  _vm._v(" "),
                                  !_vm.smartGoals || _vm.smartGoals.length === 0
                                    ? _c(
                                        "div",
                                        { staticClass: "page" },
                                        [
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "pb-3 pt-2 align-middle my-auto"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "align-middle my-auto"
                                                },
                                                [
                                                  _c("b-img", {
                                                    attrs: {
                                                      left: "",
                                                      src:
                                                        "/static/traction.png",
                                                      height: "40px"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("b-img", {
                                                    attrs: {
                                                      right: "",
                                                      src:
                                                        "/static/partial_logo.png",
                                                      height: "70px"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2 text-center" },
                                            [
                                              _c(
                                                "b-col",
                                                { staticClass: "text-left" },
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "gpc-title text-center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "S.M.A.R.T GOAL Planner"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "pb-2 text-center border-left border-right border-top border-bottom"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { staticClass: "text-left" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "gpc-title text-center goal-header"
                                                    },
                                                    [_vm._v("S")]
                                                  ),
                                                  _c("b", [
                                                    _vm._v("PECIFIC - ")
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.session.gpc
                                                          ? "GPC"
                                                          : ""
                                                      ) +
                                                      " ACTION " +
                                                      _vm._s(
                                                        _vm.session.gpc
                                                          ? "(Complete this S.M.A.R.T planner for each GPC Action)"
                                                          : ""
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "blank-line",
                                                    domProps: {
                                                      innerHTML: _vm._s(" ")
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "pb-2 text-center border-left border-right border-top border-bottom"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { staticClass: "text-left" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "gpc-title text-center goal-header"
                                                    },
                                                    [_vm._v("M")]
                                                  ),
                                                  _c("b", [
                                                    _vm._v("EASURES - ")
                                                  ]),
                                                  _vm._v(
                                                    " HOW WILL YOU KNOW IT WAS SUCCESSFUL (Lag and Lead Metrics)\n                  "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "blank-line",
                                                    domProps: {
                                                      innerHTML: _vm._s(" ")
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "pb-2 text-center border-left border-right border-top border-bottom"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { staticClass: "text-left" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "gpc-title text-center goal-header"
                                                    },
                                                    [_vm._v("A")]
                                                  ),
                                                  _c("b", [_vm._v("CTION - ")]),
                                                  _vm._v(
                                                    " LIST THE MAIN TASKS\n                  "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "blank-line",
                                                    domProps: {
                                                      innerHTML: _vm._s(" ")
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "pb-2 text-center border-left border-right border-top border-bottom"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { staticClass: "text-left" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "gpc-title text-center goal-header"
                                                    },
                                                    [_vm._v("R")]
                                                  ),
                                                  _c("b", [
                                                    _vm._v("ELEVANCE - ")
                                                  ]),
                                                  _vm._v(
                                                    " LIST BENEFITS FOR BUSINESS\n                  "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "blank-line",
                                                    domProps: {
                                                      innerHTML: _vm._s(" ")
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "pb-2 text-center border-left border-right border-top border-bottom"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { staticClass: "text-left" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "gpc-title text-center goal-header"
                                                    },
                                                    [_vm._v("T")]
                                                  ),
                                                  _c("b", [_vm._v("IME - ")]),
                                                  _vm._v(
                                                    " DECIDE TIMEFRAMES, WHEN THIS GOAL AND TASKS SHOULD BE FINISHED\n                  "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "blank-line",
                                                    domProps: {
                                                      innerHTML: _vm._s(" ")
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pt-3" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-right align-bottom sf-copy pb-0"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  © Success Formula " +
                                                      _vm._s(
                                                        _vm._f("moment")(
                                                          new Date(),
                                                          "YYYY"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-5 pb-5 text-right" },
                    [
                      _vm.session
                        ? _c(
                            "b-button",
                            {
                              staticClass: "align-self-right",
                              on: {
                                click: function($event) {
                                  _vm.print()
                                }
                              }
                            },
                            [_vm._v("Print")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4490ed78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4490ed78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmartGoalSearch.vue
// module id = null
// module chunks = 